export const checkForSvg = (url: string): boolean => {
	const fileType = url.split(/#|\?/)[0].split('.').pop();

	// falsey check is for Ts
	return fileType ? fileType.trim() === 'svg' : false;
};
